/**
 * Custom element for carousel arrows
 */

if (!customElements.get('addon-carousel-buttons')) {
  customElements.define(
    'addon-carousel-buttons',
    class AddonCarouselHandler extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.setSelectors();
        this.addEventBus();
        this.configureScroll();
        this.addReloadListeners();
      }

      /**
       * Adjusts arrows functionality
       */
      configureScroll() {
        this.getPages();
        this.addCarouselButtonEvents();
        this.setInitialIndicatorText();
      }

      /**
       * Set custom element selectors
       */
      setSelectors() {
        this.currentPage = 0;
        this.scrollSlides = document.querySelectorAll('[data-add-on-item]');
        this.carouselWrapper = document.querySelector('.addon-block__flex-box');
        this.prevButton = this.querySelector('.addon-prev-button');
        this.nextButton = this.querySelector('.addon-next-button');
        this.indicator = this.querySelector('.addon-indicator');
        this.pages = null;
      }

      /**
       * Get page count/positions from the actually rendered items, so the
       * indicator always matches the number of visible product cards
       * (container-width based math undercounts when several narrower cards,
       * e.g. the vertical style, fit within one viewport width)
       */
      getPages() {
        this.pages = Array.from(this.carouselWrapper.children).map((item) => item.offsetLeft);
      }

      /**
       * Set scroll indicator text
       */
      setInitialIndicatorText() {
        this.indicator.textContent = `1 / ${this.pages.length}`;

        this.classList.remove('hidden');
      }

      /**
       * Moves carousel to the slide
       *
       * @param {Number} index
       */
      scrollToSlide(index) {
        const scrollIndex = Math.max(0, Math.min(index, this.pages.length - 1));

        this.carouselWrapper.scrollTo({
          left: this.pages[scrollIndex],
          behavior: 'smooth',
        });

        this.currentPage = scrollIndex;
      }

      /**
       * Add listener on arrow buttons
       */
      addCarouselButtonEvents() {
        [this.prevButton, this.nextButton].forEach((button) => {
          button.addEventListener('click', () => {
            if (button === this.nextButton) {
              this.scrollToSlide(this.currentPage + 1);
            } else if (button === this.prevButton) {
              this.scrollToSlide(this.currentPage - 1);
            }

            this.indicator.textContent = `${this.currentPage + 1} / ${this.pages.length}`;
          });
        });
      }

      /**
       * Adds event bus for carousel (reload)
       */
      addEventBus() {
        const miraObject = window.miraGlobal || {};

        miraObject.events = {
          ...miraObject.events,
          carouselEventBus: new EventTarget(),
        };

        window.miraGlobal = miraObject;
      }

      /**
       * Add open/close listeners to modal
       */
      addReloadListeners() {
        miraGlobal?.events?.carouselEventBus?.addEventListener('reload', () => {
          this.configureScroll();
        });
      }
    },
  );
}
